export default "__VITE_PUBLIC_ASSET__4e5b921f__"